import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuthStore } from "@/state/useAuthStore";

/**
 * Guards routes that require an authenticated end-user. While the boot
 * refresh is in flight we render `null` (rather than redirecting) to
 * avoid a flash of /login on a hard refresh of a deep link.
 */
export function ProtectedRoute({ children, requireVerified = false }: { children: ReactNode; requireVerified?: boolean }) {
  const location = useLocation();
  const { accessToken, user, bootStatus } = useAuthStore();

  if (bootStatus !== "ready") return null;

  if (!accessToken || !user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (requireVerified && !user.emailVerified) {
    return <Navigate to="/verify-email" replace />;
  }
  return <>{children}</>;
}
